import React, { useEffect, useRef, useState } from 'react';
import { AlertCircle } from 'lucide-react';

// Функция для извлечения URL видео из разных форматов
const extractVideoUrl = (videoUrl) => {
  if (!videoUrl) return null;
  
  // Если это HTML код с iframe (как в вашем случае)
  if (videoUrl.includes('<iframe')) {
    // Ищем src атрибут
    const srcMatch = videoUrl.match(/src="([^"]+)"/);
    if (srcMatch) {
      return srcMatch[1];
    }
  }
  
  // Если это HTML код с div оберткой
  if (videoUrl.includes('kinescope.io/embed')) {
    const match = videoUrl.match(/https:\/\/kinescope\.io\/embed\/[a-zA-Z0-9]+/);
    if (match) {
      return match[0];
    }
  }
  
  // Если это уже прямая ссылка на Kinescope embed
  if (videoUrl.includes('kinescope.io/embed')) {
    return videoUrl;
  }
  
  // Если это просто ID видео Kinescope
  if (videoUrl.match(/^[a-zA-Z0-9]+$/)) {
    return `https://kinescope.io/embed/${videoUrl}`;
  }
  
  // Возвращаем как есть
  return videoUrl;
};

const KinescopePlayer = ({ videoUrl, title, className = "" }) => {
  const [error, setError] = useState(null);
  const [embedUrl, setEmbedUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Извлекаем URL при монтировании
  useEffect(() => {
    if (!videoUrl) {
      setError('Видео не найдено');
      setIsLoading(false);
      return;
    }

    try {
      console.log('Raw video URL:', videoUrl);
      const url = extractVideoUrl(videoUrl);
      console.log('Extracted URL:', url);
      
      if (url && url.includes('kinescope.io/embed')) {
        setEmbedUrl(url);
        setError(null);
      } else {
        setError('Не удалось обработать ссылку на видео');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('Error extracting video URL:', err);
      setError('Ошибка обработки видео');
      setIsLoading(false);
    }
  }, [videoUrl]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  // Если ошибка - показываем сообщение
  if (error) {
    return (
      <div className={`relative w-full h-full bg-black rounded-[24px] overflow-hidden flex items-center justify-center ${className}`}>
        <div className="text-center text-white p-4">
          <AlertCircle className="w-12 h-12 mx-auto mb-2 text-red-400" />
          <p className="mb-2">{error}</p>
          <p className="text-xs text-gray-400 break-all">ID: {videoUrl?.substring(0, 100)}...</p>
        </div>
      </div>
    );
  }

  // Если нет embed URL - показываем загрузку
  if (!embedUrl) {
    return (
      <div className={`relative w-full h-full bg-black rounded-[24px] overflow-hidden flex items-center justify-center ${className}`}>
        <div className="text-center text-white p-4">
          <div className="w-10 h-10 border-4 border-[#34D3FF] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm">Загрузка видео...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative w-full h-full bg-black rounded-[24px] overflow-hidden ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/50 z-10">
          <div className="w-10 h-10 border-4 border-[#34D3FF] border-t-transparent rounded-full animate-spin" />
        </div>
      )}
      <iframe
        src={embedUrl}
        className="w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
        allowFullScreen
        frameBorder="0"
        title={title || "Kinescope Video Player"}
        onLoad={handleIframeLoad}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default KinescopePlayer;